// --- Bucketize thresholds for M3 metric tags ---
export const COMPLEXITY_THRESHOLDS = ([1000, 10000, 50000, 200000] as const);
export const TOTAL_POINT_COUNT_THRESHOLDS = ([5000, 25000, 100000, 500000] as const);
export const FRAME_POINT_COUNT_THRESHOLDS = ([100, 500, 2000, 10000] as const);
export const FRAME_COUNT_THRESHOLDS = ([100, 500, 1000, 5000, 10000] as const);
export const VIDEO_SIZE_THRESHOLDS = ([50, 200, 500, 1000] as const);
export const SESSION_DURATION_THRESHOLDS = ([5, 15, 30, 60] as const);

// --- Heap gauge ---
export const HEAP_GAUGE_INTERVAL_MS = 60_000;

// --- Performance metric event names ---
export const PERFORMANCE_METRIC_EVENTS = ({
  /** Periodic browser heap usage gauge (every 60s, Chrome-only) */
  BROWSER_HEAP_USED_MB: 'browser_heap_used_mb',
  /** Heap growth in MB since session start — GC-independent leak signal (every 60s, Chrome-only) */
  BROWSER_HEAP_GROWTH_MB: 'browser_heap_growth_mb',
  /** Annotation click dispatch to browser paint (shape, side panel, or timeline click) */
  ANNOTATION_SELECT_TO_PAINT: 'annotation_select_to_paint',
  /** Annotation hover dispatch to browser paint (shape onMouseEnter) */
  ANNOTATION_HOVER_TO_PAINT: 'annotation_hover_to_paint',
  /** Total time from extraction start to frame table + IDB cache ready */
  FRAME_EXTRACTION_TOTAL_TIME: 'frame_extraction_total_time',
  /** Accumulated IDB write time during frame extraction */
  FRAME_EXTRACTION_STORAGE_TIME: 'frame_extraction_storage_time',
  /** Time from decode request to ImageBitmap received on main thread */
  FRAME_DECODE_LATENCY: 'frame_decode_latency',
  /** Time to draw decoded ImageBitmap to canvas overlay */
  FRAME_DECODE_CANVAS_DRAW_TIME: 'frame_decode_canvas_draw_time',
  /** Error during frame extraction (demux/stream/store failures) */
  FRAME_EXTRACTION_ERROR: 'frame_extraction_error',
  /** Error during frame decode (decoder/cache/chunk failures) */
  FRAME_DECODE_ERROR: 'frame_decode_error',
  /** Ratio of dropped video frames during a play session */
  PLAYBACK_DROPPED_FRAME_RATIO: 'playback_dropped_frame_ratio',
  /** Annotation drag dispatch to browser paint (only emitted if >16ms) */
  DRAG_TO_PAINT: 'drag_to_paint',
  VIDEO_SEEK_TO_PAINT: 'video_seek_to_paint',
  VIDEO_PLAY_TO_PAINT: 'video_play_to_paint',
  VIDEO_PAUSE_TO_PAINT: 'video_pause_to_paint'
} as const);

/** Default minimum interval between consecutive paint latency measurements (ms) */
export const DEFAULT_PAINT_LATENCY_THROTTLE_MS = 200;